import { create } from "zustand";
import {
  getPlaygroundProjectId,
  setPlaygroundProjectId,
} from "@/utils/requestScope";

interface PlaygroundProjectState {
  // Empty string means "all projects" (no X-Project-ID scoping).
  projectId: string;
  setProjectId: (projectId: string) => void;
}

// localStorage (via requestScope) is the source of truth read imperatively by
// the request interceptor and the stream fetcher; this store mirrors it so the
// UI stays reactive.
export const usePlaygroundProject = create<PlaygroundProjectState>((set) => ({
  projectId: getPlaygroundProjectId() ?? "",
  setProjectId: (projectId) => {
    setPlaygroundProjectId(projectId || null);
    set({ projectId });
  },
}));
